import { useState } from 'react'
import { useBreadcrumb } from '../hooks/useBreadcrumb'
import { FaSearch, FaShippingFast } from 'react-icons/fa'
import { Card, Button, PageHeader } from '../components/common'

/*
 * 注释保留，不是删除：状态筛选下拉与「重置」按钮在下方「订单列表」卡头里是注释状态。
 * 放开那段 JSX 时，把这里的 statusOptions、以及组件内的 statusFilter / handleReset 一起放开。
 *
 * const statusOptions = [
 *   { value: '', label: '全部状态' },
 *   { value: 'pending', label: '待处理' },
 *   { value: 'processing', label: '处理中' },
 *   { value: 'shipped', label: '已发货' },
 *   { value: 'in_transit', label: '运输中' },
 *   { value: 'delivered', label: '已送达' },
 *   { value: 'completed', label: '已完成' },
 * ]
 */

export default function ConsolidationOrderPage() {
  const breadcrumb = useBreadcrumb()
  const [searchCode, setSearchCode] = useState('')
  // const [statusFilter, setStatusFilter] = useState('')   // 与上方 statusOptions 一同放开

  const handleSearch = () => {
    // 静态页面，暂不实现搜索逻辑
  }

  // const handleReset = () => {
  //   setSearchCode('')
  //   setStatusFilter('')
  // }

  return (
    <div>
      <PageHeader
        icon={FaShippingFast}
        title="集运订单"
        subtitle="查看集运订单状态和物流信息"
        breadcrumb={breadcrumb}
      />

      <div className="container py-8">
        {/* 搜索卡片 - 参考 InspectionPage 样式 */}
        <Card className="mb-8">
          <Card.Body>
            <div className="max-w-2xl mx-auto">
              <h3 className="text-fluid-lg font-semibold mb-4 text-center">请输入报名单号/订单编号查询</h3>
              {/* 小屏竖排：并排时输入框只剩 96px，placeholder 完全看不到 */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <div className="flex-1 min-w-0">
                  <input
                    type="text"
                    className="form-control sm:text-lg"
                    placeholder="请输入报名单号/订单编号"
                    value={searchCode}
                    onChange={(e) => setSearchCode(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                  />
                </div>
                <Button size="lg" onClick={handleSearch} icon={<FaSearch />} className="w-full sm:w-auto shrink-0">
                  查询
                </Button>
              </div>
            </div>
          </Card.Body>
        </Card>

        {/* 订单列表 */}
        <Card>
          <Card.Header>
            <div className="flex items-center justify-between">
              <h4 className="font-semibold">订单列表</h4>
              {/* <div className="flex items-center gap-3">
                <select
                  className="form-control text-sm"
                  style={{ width: 150 }}
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  {statusOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
                <Button variant="secondary" size="sm" onClick={handleReset}>
                  重置
                </Button>
              </div> */}
            </div>
          </Card.Header>
          <Card.Body className="p-0">
            {/* 小屏不渲染 1000px 宽的表格骨架（要横拖 3 屏）。等有真实数据时
                这里按 MobileCard 铺卡片，与我的报名/我的订单一致。 */}
            <div className="md:hidden px-4 py-12 text-center text-gray-500">
              暂无订单记录
            </div>

            <div className="hidden md:block overflow-x-auto">
              <table className="table" style={{ minWidth: 1000 }}>
                <thead>
                  <tr>
                    <th className="whitespace-nowrap text-center">订单编号</th>
                    <th className="whitespace-nowrap text-center">报名编号</th>
                    <th className="whitespace-nowrap text-center">物品名称</th>
                    <th className="whitespace-nowrap text-center">件数</th>
                    <th className="whitespace-nowrap text-center">总重量(kg)</th>
                    <th className="whitespace-nowrap text-center">目的国家</th>
                    <th className="whitespace-nowrap text-center">物流方式</th>
                    <th className="whitespace-nowrap text-center">订单状态</th>
                    <th className="whitespace-nowrap text-center">创建时间</th>
                    <th className="whitespace-nowrap text-center">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={10} className="text-center text-gray-500 py-12">
                      暂无订单记录
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}
